import en from './bridge.en';

const enConfig = { en };

export default enConfig;
